<div class="full-height layout-column">
  <div class="flex layout-column bringoz-table table-outer-wrapper"
       [ngClass]="tableClass"
       [style.--bringoz-table-row-height]="rowHeightPx"
       [style.--bringoz-table-header-height]="headerHeightPx"
       [hidden]="hideWhenEmpty && showEmptyState"
       tableScrollSync>

    <div class="header-container"
         [tableColumnManager]="uniqueId"
         [resizable]="resizable"
         [defaultWidths]="defaultWidths"
         [settings]="settings"
         (settingsChange)="onSettingsChange($event)">
      <div class="table-inner-wrapper">
        <div class="tr sticky-header">
          <ng-container *ngIf="headerDef" [ngTemplateOutlet]="headerDef.templateRef"></ng-container>
        </div>
      </div>
    </div>

    <cdk-virtual-scroll-viewport [itemSize]="resolvedRowHeight" class="body-container" (scroll)="onBodyScroll()">
      <div class="table-inner-wrapper">
        <ng-container *cdkVirtualFor="let item of items; let index = index; trackBy: trackByFn">
          <ng-container *ngIf="rowDef"
                        [ngTemplateOutlet]="rowDef.templateRef"
                        [ngTemplateOutletContext]="{$implicit: item, index: index}">
          </ng-container>
        </ng-container>
      </div>
    </cdk-virtual-scroll-viewport>

  </div>

  <div *ngIf="showEmptyState"
       class="flex-100 full-height layout-row layout-align-center-center overflow-auto fade-element-in-only">
    <ng-content select="[tableEmptyState]"></ng-content>
  </div>
</div>
